module.exports = __webpack_public_path__ + "img/同济大学.aa7f6c93.png";